/* eslint-disable react/style-prop-object */
/* eslint-disable max-len */
import { FC } from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Card, CardContent, Container } from "@mui/material";
import classes from "./style";

const CookiesPage: FC<{}> = () => {
  return (<>
    <Container disableGutters maxWidth={false} sx={classes.authContainer}>
      <Box sx={{ width: '90%' }}>
        <Card sx={{ ...classes.card, borderTopLeftRadius: "15px !important", height: "100%", position: "relative" }}>
          <CardContent
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              height: "100%",
            }}
          >
            <Box sx={{ mt: 2 }}>
              <Typography sx={classes.label}>POLITIQUE COOKIES</Typography>

              1 Les cookies déployés par CALADRE sont conformes à (i) la directive UE &quot;e-Privacy&quot;
              du 12 juillet 2022, (ii) l’article 82 de la loi LIL, (iii) la délibération CNIL n°2020-091, et
              (iv) la délibération CNIL n°2020-092 du 17 septembre 2020, complétées par (v) des
              questions-réponses de la CNIL publiées le 18 mars 2021 (ci-après &quot;Règlementation
              Cookies/Traceurs&quot;).
              <br /><br />1.1 La Règlementation Cookies/Traceurs impose aujourd&#39;hui à tout professionnel
              comme CALADRE souhaitant déposer un cookie sur le terminal d&#39;un Visiteur ou
              d&#39;un Membre le recueil préalable de son consentement.
              <br /><br />1.2 Par exception, la Règlementation Cookies/Traceurs permet aujourd&#39;hui d&#39;implanter
              un Cookie/Traceur dans un Terminal, sans demande de consentement (mais avec
              information préalable) d’un Visiteur ou d&#39;un Membre et donc d&#39;utiliser les capacités
              de traitement et/ou de stockage de son terminal et de procéder à des opérations de
              lecture et/ou d’écriture d’informations lorsque le Cookie/Traceur :
              <br />(i) &quot;soit a pour finalité exclusive de permettre ou faciliter la communication par
              voie électronique&quot; ;
              <br />(ii) &quot;soit est strictement nécessaire à la fourniture d&#39;un service de communication
              en ligne à la demande expresse de l&#39;utilisateur&quot; (délibération CNIL n°2020-091).
              <br /><br />1.3 A ce titre, les Cookies/Traceurs mis en œuvre par CALADRE sont exclusivement
              des cookies &quot;first party&quot; qui bénéficient du régime des exemption à la demande de
              consentement préalable (délibération CNIL n°2020-091):
              <br />(i) &quot;les traceurs conservant le choix exprimé par les utilisateurs sur le dépôt de
              traceurs;
              <br />(ii) les traceurs destinés à l’authentification auprès d’un service, y compris ceux
              visant à assurer la sécurité du mécanisme d’authentification, par exemple en
              limitant les tentatives d’accès robotisées ou inattendues ;
              <br />(ii) les traceurs destinés à garder en mémoire le contenu d’un panier d’achat sur
              un site marchand ou à facturer à l’utilisateur le ou les produits et/ou services
              achetés ;
              <br />(iv) les traceurs de personnalisation de l&#39;interface utilisateur (par exemple, pour le
              choix de la langue ou de la présentation d’un service), lorsqu’une telle
              personnalisation constitue un élément intrinsèque et attendu du service ;
              <br />(v) les traceurs permettant l&#39;équilibrage de la charge des équipements concourant
              à un service de communication ;
              <br />(vi) les traceurs permettant aux sites payants de limiter l’accès gratuit à un
              échantillon de contenu demandé par les utilisateurs (quantité prédéfinie et/ou
              sur une période limitée) ;
              <br />(vii) &quot;les traceurs de mesure d’audience du site ou de l’application, pour répondre
              à différents besoins (mesure des performances, détection de problèmes de
              navigation, optimisation des performances techniques ou de l’ergonomie,
              estimation de la puissance des serveurs nécessaires, analyse des contenus
              consultés, etc.)&quot;.

            </Box>
          </CardContent>
        </Card>
      </Box>
    </Container >
  </>
  );
};

export default CookiesPage;
